import http from './http'

const basePath = '/Telas/PagamentoManual'

export default {
  async getOptions () {
    const response = await http.get(`${basePath}/GetOptions`)
    return response.data
  },
  async getEligibleInstallments (params) {
    const response = await http.get(`${basePath}/GetEligibleInstallments`, { params })
    return response.data
  },
  async add (input) {
    const response = await http.post(`${basePath}/Add`, input)
    return response.data
  }
}
